import config from '@/utils/config'
import CryptoJS from 'crypto-js'

const encrypt = (data = {}) =>
  CryptoJS.AES.encrypt(JSON.stringify(data), config.cipherKey).toString()

const decrypt = (data = '') =>
  JSON.parse(CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(data, config.cipherKey)))

export default { encrypt, decrypt }